/**
 * Meta Embedded Signup configuration.
 *
 * Set VITE_META_APP_ID and VITE_META_CONFIG_ID in an untracked .env.local —
 * never commit real credentials. When either is missing the Intégrations tab
 * renders a "non configuré" state instead of opening the Meta popup.
 */

// Placeholder default: confirm against Meta's current Graph API version before
// shipping to production.
const DEFAULT_GRAPH_VERSION = "v23.0";

const read = (value: unknown) => (typeof value === "string" ? value.trim() : "");

export const whatsappConfig = {
  appId: read(import.meta.env.VITE_META_APP_ID),
  configId: read(import.meta.env.VITE_META_CONFIG_ID),
  // `||` on purpose here: an empty variable must fall back to the default,
  // which `??` would not do.
  graphVersion:
    read(import.meta.env.VITE_META_GRAPH_VERSION) || DEFAULT_GRAPH_VERSION,
};

export const isWhatsAppSignupConfigured = () =>
  whatsappConfig.appId !== "" && whatsappConfig.configId !== "";
